import { render, staticRenderFns } from "./AddPFAC.vue?vue&type=template&id=efc59fc0"
import script from "./AddPFAC.vue?vue&type=script&lang=js"
export * from "./AddPFAC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports